import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { AppSettingsProvider } from "./contexts/AppSettingsContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import POS from "./pages/POS";
import Transactions from "./pages/Transactions";
import TransactionDetail from "./pages/TransactionDetail";
import Inventory from "./pages/Inventory";
import Customers from "./pages/Customers";
import Services from "./pages/Services";
import Shifts from "./pages/Shifts";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Users from "./pages/Users";
import PaymentMethods from "./pages/PaymentMethods";
import WashingMachines from "./pages/WashingMachines";
import Printer from "./pages/Printer";
import TrackOrder from "./pages/TrackOrder";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  return user ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" />;
  if (user.role !== "admin") return <Navigate to="/pos" />;
  return children;
};

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/track" element={<TrackOrder />} />
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route
          index
          element={
            user?.role === "kasir" ? (
              <Navigate to="/pos" />
            ) : user?.role === "penyetrika" ? (
              <Navigate to="/transactions" />
            ) : (
              <Dashboard />
            )
          }
        />
        <Route path="pos" element={<POS />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="transactions/:id" element={<TransactionDetail />} />
        <Route
          path="inventory"
          element={
            <AdminRoute>
              <Inventory />
            </AdminRoute>
          }
        />
        <Route path="customers" element={<Customers />} />
        <Route
          path="services"
          element={
            <AdminRoute>
              <Services />
            </AdminRoute>
          }
        />
        <Route path="shifts" element={<Shifts />} />
        <Route path="printer" element={<Printer />} />
        <Route
          path="reports"
          element={
            <AdminRoute>
              <Reports />
            </AdminRoute>
          }
        />
        <Route
          path="settings"
          element={
            <AdminRoute>
              <Settings />
            </AdminRoute>
          }
        />
        <Route
          path="users"
          element={
            <AdminRoute>
              <Users />
            </AdminRoute>
          }
        />
        <Route
          path="payment-methods"
          element={
            <AdminRoute>
              <PaymentMethods />
            </AdminRoute>
          }
        />
        <Route
          path="washing-machines"
          element={
            <AdminRoute>
              <WashingMachines />
            </AdminRoute>
          }
        />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AppSettingsProvider>
      <AuthProvider>
        <Router
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <AppRoutes />
          <ToastContainer position="top-right" autoClose={3000} />
        </Router>
      </AuthProvider>
    </AppSettingsProvider>
  );
}

export default App;
